import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @ViewChild('mobileMenu') mobileMenu: ElementRef;
  @Input() showMenu: boolean = false;

  menuItems: any = [
    { title: 'خانه', link: '/' },
    { title: 'درباره ایپام', link: '/about-us' },
    { title: 'باگ بانتی ایپام', link: '/bug-bounty' },
    { title: 'مجوزها', link: '/certificate' },

    {
      title: 'راه‌کارها ▾',
      link: '/solutions',
      submenu: [
        { title: 'اختصاصی', link: '/exclusive' },
        { title: 'مالی', link: '/financial' }
      ]
    },
    {
      title: 'برندها ▾',
      link: '/brands',
      submenu: [
        { title: 'پرداخت‌یاری گردش پی', link: '/pardakhtyari' },
        // { title: 'پرداخت‌سازی', link: '/pardakhtsazi' },
        // { title: 'پرداخت‌بانی', link: '/pardakhtbani' },
        // { title: 'سوپر اپلیکیشن توبانک', link: '/tobank' },
        { title: 'هتل سیس', link: '/hotelsys' }
      ]
    },
    { title: 'فرصت‌های شغلی', link: '/job-offer' },
    { title: 'تماس با ما', link: '/contact-us' }
    // { title: 'نقشه راه', link: '/road-map' }
  ];

  constructor(public router: Router, private renderer: Renderer2) {}
  ngOnInit(): void {}

  onMenuClick(item: any): void {
    if (item.submenu) {
      item.checked = !item.checked;
    } else {
      this.showMenu = false;
      this.router.navigate([item.link]);
    }
  }
}
